/* eslint-disable react-hooks/exhaustive-deps */
import { CircularProgress } from '@material-ui/core';
import { useModal } from 'hooks/modal';
import React, { useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import { i18n } from 'translate/i18n';
import { putRequest } from 'utils/request';
import { getRequest } from 'utils/request';


function TabSkute({ handleGoBack, companyData }) {
  const [loading, setLoading] = useState(false);
  const [BotId, setBotId] = useState("")
  const [bot, setBot] = useState(false);
  const [bots, setBots] = useState([]);
  const { toggleHelperId } = useModal();
  const [code, setCode] = useState("");
  const textAreaRef = useRef(null);

  const loadSkuteSettings = () => {
    setLoading(true);
    getRequest(`/companieschannels/settings/skute?CompanyId=${companyData.id}`)
      .then((resp) => {
        setCode(resp.data.html)
        if (resp.data.data.BotId) {
          setBot(true);
          setBotId(resp.data.data.BotId);
        }
        getRequest(`/bots?companyId=${companyData.id}&onlyActive=1`)
          .then(function (response) {
            setBots(response.data);
            setLoading(false);
          }
          )
      })
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    toast.info(i18n.t('successCopy'));
  }

  const handleSubmit = () => {
    setLoading(true);
    putRequest(`/companieschannels/settings/skute`, {
      CompanyId: companyData.id,
      BotId: BotId ? Number(BotId) : null
    })
      .then(function () {
        setLoading(false);
        handleGoBack();
      });
  }

  useEffect(() => {
    loadSkuteSettings();
  }, [companyData]);

  useEffect(() => {
    if (bot === false) {
      setBotId('');
    }
  }, [bot]);

  useEffect(() => {
    toggleHelperId(27);
  }, [])

  return (
    <div style={{ minHeight: 300 }}>
      <div className="title-helper-container">
        <h3>{companyData.nickName}</h3>
      </div>
      <h3>SKUTE</h3>
      {!loading ? (
        <form
          className="form-edit"
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit()
          }}
        >
          <div style={{ paddingLeft: 0 }} className="form-group col-md-12">
            <div style={{ height: '50vh' }}>
              <div style={{ marginTop: 10 }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    checked={bot}
                    onChange={(value) => {
                      setBot(value.target.checked);
                    }}
                  />
                  <label style={{ marginLeft: 5 }} className="col-form-label">{i18n.t('attendanceBot')}:</label>
                </div>
                {bot &&
                  <div className="form-bot">
                    <select
                      className="select2 form-control select2-multiple"
                      style={{
                        width: 200,
                      }}
                      required={bot === true}
                      value={BotId || ''}
                      onChange={(e) => setBotId(e.target.value)}
                    >
                      {bots.length > 0 ?
                        <>
                          <option value="">{i18n.t('chooseOne')}</option>

                          {bots.map(bot => {
                            return (
                              <option key={bot.id} value={bot.id}>{bot.description}</option>
                            )
                          })}
                        </>
                        :
                        <option value="">{i18n.t('doesNotHaveBot')}</option>
                      }
                    </select>
                  </div>
                }
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <label className="col-form-label">{i18n.t('implementCodeSkute')}</label>
                    <textarea
                      rows="5"
                      cols="200"
                      required
                      style={{ resize: 'none' }}
                      disabled
                      ref={textAreaRef}
                      className="form-control"
                      defaultValue={code}
                    />
                    <button style={{ top: 132 }} type="button" className="copyButton" onClick={handleCopy}>
                      <i className="far fa-copy" style={{ fontSize: 20 }}></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="button-list mt-3 pull-right"
              style={{ display: 'flex', justifyContent: 'flex-end', alignSelf: 'flex-end' }}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => handleGoBack()}
              >
                <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('getBack')}
              </button>
              <button type="submit" className="btn btn-outline-success">
                <i className="mdi mdi-checkbox-marked-circle"></i> {i18n.t('save')}
              </button>
            </div>
          </div>
        </form>
      ) : (
        <div className="area-loading">
          <CircularProgress />
        </div>
      )}
    </div>
  );
}

export default TabSkute;
